

















import { Vue, Component, Prop } from 'vue-property-decorator'
import ItemDeTopPeca from './ItemDeTopPeca.vue'
import type { TopPecaDoCliente } from '@/models'
import { TEXTO_SEM_DADOS } from '@/shareds/painel-do-cliente-shareds'
import { ordenarTopPecas, resumirTopPecas } from '@/shareds/painel-do-cliente-mix-shareds'

@Component({
	components: {
		ItemDeTopPeca,
	},
})
export default class TopPecas extends Vue {
	@Prop({ type: Array, default: () => [] }) topPecas!: TopPecaDoCliente[]
	@Prop({ type: Boolean, default: true }) resumido!: boolean

	textoSemDados = TEXTO_SEM_DADOS

	get exibidas() {
		return this.resumido ? resumirTopPecas(this.topPecas) : ordenarTopPecas(this.topPecas)
	}
}
